import { Component } from '@angular/core';
import { IonicPage, ViewController } from 'ionic-angular';

import { ConfigProvider } from '../../providers/config/config';
import { DeviceProvider } from '../../providers/device/device';
import { WebrtcProvider } from '../../providers/webrtc/webrtc';

import Bowser from "bowser";
import { DeviceType } from '../../models/models';
import { AuthProvider } from '../../providers/auth/auth';


@IonicPage()
@Component({
	selector: 'page-credits-modal',
	templateUrl: 'credits-modal.html',
})
export class CreditsModalPage {
	public appName: string = ConfigProvider.APPLICATION_NAME;
	public system: any;
	private dismissTimeout: number = null;

	constructor(
		public auth: AuthProvider,
		public viewCtrl: ViewController,
		public devices: DeviceProvider,
		public webrtc: WebrtcProvider
	) {
		console.debug('Bowser', Bowser)
		try {
			let parser = Bowser.getParser(window.navigator.userAgent || navigator.userAgent);
			console.debug('Bowser browser parser:', parser)
			this.system = (parser as any).parsedResult;
			console.debug('Bowser broser parser.parsedResult:', this.system)
		} catch (e) {
			console.error('Errore inizializzando Bowser', e)
		}
	}

	dismiss() {
		this.viewCtrl.dismiss();
	}


	/**
	Va in background
	*/
	ionViewDidLeave() {
		//evitiamo di chiudere se già chiuso
		let timeout = this.dismissTimeout
		if (timeout) {
			clearTimeout(timeout);
		}
	}
	/**
	Va in primo piano
	*/
	ionWillEnter() {
		//se deve imposta un timeout di autochiusura
		let actualType = this.devices.actualType;
		console.log('Aprendo modale, tipo del dispositivo attuale:', actualType);
		if (actualType == DeviceType.INTERCOM || actualType == DeviceType.DASHBOARD) {
			console.log('Device pubblico, chiusura automatica modale dopo 60 secondi');
			let self = this;
			this.dismissTimeout = setTimeout(() => {
				self.dismissTimeout = null;
				self.viewCtrl.dismiss()
			}, 60000);
		}
	}
}



// WEBPACK FOOTER //
// ./src/pages/credits-modal/credits-modal.ts